import "../css/TwoColumnsTextRight.css";
import { useState, Suspense, lazy } from "react";
import { Flex, Button } from 'antd';
import ReactPlayer from "react-player";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import { useQuery } from "@apollo/client";
import {
  GET_TWO_COLUMS_TEXT_RIGHT_BY_SLUG,
} from "../queries";
import ButtonComp from "./ButtonComp";
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl";
import isImageOrVideo from "../utils/isImageOrVideo";

const componentMap = {
  Accordion: lazy(() => import("./Accordion/Card")),
  Contact: lazy(() => import("../components/Forms/Contact")),
  MarketForm: lazy(() => import("../components/Forms/Market")),
};

const ShowMedia = ({ mediaItemUrl }) => {
  const mediaType = isImageOrVideo(mediaItemUrl);
  if (mediaType === "image") {
    return (
      <div
        className="TwoColumnsTextRight-box TwoColumnsTextRight-image"
        style={{
          backgroundImage: `url(${setImageAbsoluteUrl(mediaItemUrl)})`,
        }}
      />
    );
  } else if (mediaType === "video") {
    return (
      <ReactPlayer
        className="react-player-rounded"
        url={setImageAbsoluteUrl(mediaItemUrl)}
        width="100%"
        height="auto"
        playing={true}
        loop={true}
        muted={true}
        volume={0}
        controls={false}
        playsinline
      />
    );
  }
};

const TwoColumnsTextRight = ({ page, section, comp, lang }) => {
  const slug = `${page}-${section}-${lang}`; 
  const DynamicComponent = comp && componentMap[comp];

  const [sectionData, setSectionData] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null;
  });

  const { loading, error, data } = useQuery(GET_TWO_COLUMS_TEXT_RIGHT_BY_SLUG, {
    variables: { slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {
      const postData = fetchedData.sectionsBy?.twocolumnstextright;      
      const dataToLocal = {
        ...sectionData,
        sections: {
          [slug]: postData,
        },
      };
      saveToLocalStorage(page, dataToLocal);
      setSectionData(postData);
    },
  });

  return (
    <>
      {sectionData && (
        <Flex className="TwoColumnsTextRight">
          {sectionData?.tituloTctr && (
            <Flex className="TwoColumnsTextRight-title">
              <Flex>
                <h2
                  className="h4-headline-500"
                  dangerouslySetInnerHTML={{ __html: sectionData.tituloTctr }}
                />
              </Flex>
              {sectionData?.linkTctr?.url && (
                <Button 
                  className="bt-medium-500" 
                  style={{color: '#0027F9' }} 
                  type="link" 
                  href={sectionData?.linkTctr?.url || '#'} 
                  variant="link">
                    {sectionData?.linkTctr?.title || 'Get Started'}
                </Button>
              )}
            </Flex>
          )}
          <Flex className="TwoColumnsTextRight-content">
            {sectionData?.imagenIzquierdaTctr?.node?.mediaItemUrl ? (
              <ShowMedia mediaItemUrl={sectionData?.imagenIzquierdaTctr?.node?.mediaItemUrl} />
            ) : null}
            <Flex className="TwoColumnsTextRight-box TwoColumnsTextRight-text">
              {comp ? (
                <Suspense fallback={<div>Loading...</div>}>
                  <DynamicComponent data={sectionData?.contenido} lang={lang}/>
                </Suspense>
              ) : (
                <>
                  <div
                    className="b2-body-400"
                    dangerouslySetInnerHTML={{ __html: sectionData?.contenidotctr }}
                  />
                  <ButtonComp
                    title={sectionData.botontctr?.title || "button title"}
                    url={sectionData.botontctr?.url || "#"}
                    classStyle={
                      sectionData?.btnClass
                        ? `bt-medium-500 ${sectionData?.btnClass}`
                        : "button-empty-md bt-medium-500"
                    }
                  />
                </>
              )}
            </Flex>
          </Flex>
        </Flex>
      )}
    </>
  );
};

export default TwoColumnsTextRight;
